import { createLogic } from 'redux-logic'
import handleErrors from '@app/helpers/handleErrors'
import { SORT_MY_DEVICES } from '@app/constants/myDevices/myDevices'
import { API_REQUEST_CANCEL } from '@app/constants/apiRequest'
import { apiRequestDone, apiRequestFailed, apiRequestSent } from '@app/actions/apiRequest'
import Api from '@app/api/myDevices/myDevices'

const putSortMyDevices = createLogic({
  type: SORT_MY_DEVICES,
  latest: true,
  cancelType: API_REQUEST_CANCEL,

  transform({ getState, action }, next) {
    const { secrets: { accessToken: { token: accessToken } } } = getState()
    const { myDevices: { myDevices: { devices } } } = getState()
    next({
      ...action,
      accessToken,
      devices,
    })
  },

  async process({ action }, dispatch, done) {
    dispatch(apiRequestSent(SORT_MY_DEVICES))
    const data = { order: action.devices.map((device) => ({ id: device.id, device_type: device.device_type })) }
    try {
      await Api.sortDevices(action.accessToken, data)
      dispatch(apiRequestDone(SORT_MY_DEVICES))
    } catch (error) {
      if (error) {
        const currentError = handleErrors(error)
        dispatch(apiRequestFailed(currentError))
      } else {
        throw new Error('SORT_MY_DEVICES failed without error')
      }
    }
    done()
  },
})

export default putSortMyDevices
